export default "__VITE_ASSET__DxAzhGER__"